module.exports = __webpack_public_path__ + "static/media/dharmachakra.0523c6ce.svg";